import React, { useState, useEffect } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  Checkbox,
  FormControlLabel,
  Avatar,
  TextField,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ExcursionDetailsModalMobile({ open, onClose, excursionData }) {
  // On considère attendances comme un tableau d'objets.
  const [attendances, setAttendances] = useState([]);
  // Les clés dans editModes seront "clientId_depart" pour la zone depart et "clientId_arrived" pour la zone arrived.
  const [editModes, setEditModes] = useState({});
  const [localNotes, setLocalNotes] = useState({});
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  // Synchronisation des attendances : conversion en tableau si nécessaire.
  useEffect(() => {
    let att;
    if (excursionData.attendances) {
      att = Array.isArray(excursionData.attendances)
        ? excursionData.attendances
        : Object.values(excursionData.attendances);
    } else {
      att = [];
    }
    setAttendances(att);
  }, [excursionData]);

  // Fonctions pour obtenir la note "depart" d'un client.
  const getClientNote = (clientId) => {
    const client = attendances.find((att) => att.id === clientId);
    return client ? client.note || "" : "";
  };

  // Pour "arrived".
  const getClientNoteArrived = (clientId) => {
    const client = attendances.find((att) => att.id === clientId);
    return client ? client.noteArrived || "" : "";
  };

  // Mise à jour locale des notes.
  const handleNoteChange = (key, event) => {
    const newText = event.target.value;
    setLocalNotes((prev) => ({ ...prev, [key]: newText }));
  };

  // Bascule du mode édition et sauvegarde de la note dans Firestore.
  // Le second paramètre isArrived détermine la zone (true pour "arrived", false pour "depart").
  const handleToggleEdit = (clientId, isArrived = false) => {
    const key = clientId + (isArrived ? "_arrived" : "_depart");
    const isEditing = editModes[key] || false;
    if (isEditing) {
      const newNote =
        localNotes[key] !== undefined
          ? localNotes[key]
          : isArrived
          ? getClientNoteArrived(clientId)
          : getClientNote(clientId);
      const updatedAttendances = attendances.map((att) =>
        att.id === clientId
          ? {
              ...att,
              ...(isArrived ? { noteArrived: newNote } : { note: newNote }),
            }
          : att
      );
      setAttendances(updatedAttendances);
      const docRef = doc(db, "clientExcursions", excursionData.id);
      updateDoc(docRef, { attendances: updatedAttendances }).catch((error) =>
        console.error("Error saving note:", error)
      );
    }
    setEditModes((prev) => ({ ...prev, [key]: !isEditing }));
  };

  // Gestion des changements de checkbox pour "depart" et "arrived".
  const handleCheckboxChange = async (clientId, field, event) => {
    const newValue = event.target.checked;
    const updatedAttendances = attendances.map((att) =>
      att.id === clientId ? { ...att, [field]: newValue } : att
    );
    setAttendances(updatedAttendances);
    try {
      const docRef = doc(db, "clientExcursions", excursionData.id);
      await updateDoc(docRef, { attendances: updatedAttendances });
    } catch (error) {
      console.error("Error updating attendance:", error);
    }
  };

  const getCheckboxValue = (clientId, field) => {
    const client = attendances.find((att) => att.id === clientId);
    return client ? client[field] || false : false;
  };

  // Gestion du clic sur l'avatar pour agrandir l'image.
  const handleAvatarClick = (client) => {
    const url =
      client.profilePicture ||
      "https://via.placeholder.com/150/CCCCCC/FFFFFF/?text=Avatar";
    setEnlargedImage(url);
    setSelectedClient(client);
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setEnlargedImage(null);
    setSelectedClient(null);
  };

  useEffect(() => {
    const docRef = doc(db, "clientExcursions", excursionData.id);
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const updatedAttendances = docSnap.data().attendances;
        if (
          JSON.stringify(updatedAttendances) !== JSON.stringify(attendances)
        ) {
          setAttendances(updatedAttendances);
        }
      }
    });
    return () => unsubscribe();
  }, [excursionData.id, attendances]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
            {`Excursion - ${excursionData.date} - ${excursionData.shift.time} - ${excursionData.shift.name}`}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <List>
          {attendances.map((client) => (
            <ListItem
              key={client.id}
              button
              sx={{
                border: "1px solid lightgrey",
                borderRadius: "5px",
                mb: 1,
                backgroundColor:
                  getCheckboxValue(client.id, "depart") &&
                  getCheckboxValue(client.id, "arrived")
                    ? "lightgreen"
                    : "inherit",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  mr: 2,
                  justifyContent: "center",
                  alignContent: "center",
                  maxWidth: "30%",
                  minWidth: "30%",
                }}
                onClick={() => handleAvatarClick(client)}
              >
                <Avatar
                  src={
                    client.profilePicture ||
                    "https://via.placeholder.com/40/CCCCCC/FFFFFF/?text=Avatar"
                  }
                  alt={`${client.firstName} ${client.lastName}`}
                  sx={{ width: 60, height: 60 }}
                />
                <Typography
                  variant="body2"
                  sx={{ mt: 0.5, textAlign: "center" }}
                  noWrap
                >
                  {client.firstName} {client.lastName}
                </Typography>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                {/* Section Depart */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={getCheckboxValue(client.id, "depart")}
                      onChange={(e) =>
                        handleCheckboxChange(client.id, "depart", e)
                      }
                    />
                  }
                  label="Depart"
                />
                {editModes[client.id + "_depart"] ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TextField
                      multiline
                      rows={2}
                      value={
                        localNotes[client.id + "_depart"] !== undefined
                          ? localNotes[client.id + "_depart"]
                          : getClientNote(client.id)
                      }
                      onChange={(e) =>
                        handleNoteChange(client.id + "_depart", e)
                      }
                      variant="outlined"
                      size="small"
                      sx={{ maxWidth: 200, height: 48, overflow: "auto" }}
                      InputProps={{
                        sx: {
                          padding: "4px 8px",
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                        },
                      }}
                    />
                    <IconButton
                      onClick={() => handleToggleEdit(client.id, false)}
                      size="small"
                    >
                      <SaveIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TextField
                      value={getClientNote(client.id) || "No note"}
                      variant="outlined"
                      size="small"
                      disabled
                      multiline
                      sx={{ maxWidth: 200, height: 48, overflow: "auto" }}
                      InputProps={{
                        sx: {
                          padding: "4px 8px",
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                        },
                      }}
                    />
                    <IconButton
                      onClick={() => handleToggleEdit(client.id, false)}
                      size="small"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
                {/* Section Arrived */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={getCheckboxValue(client.id, "arrived")}
                      onChange={(e) =>
                        handleCheckboxChange(client.id, "arrived", e)
                      }
                    />
                  }
                  label="Arrived"
                />
                {editModes[client.id + "_arrived"] ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TextField
                      multiline
                      rows={2}
                      value={
                        localNotes[client.id + "_arrived"] !== undefined
                          ? localNotes[client.id + "_arrived"]
                          : getClientNoteArrived(client.id)
                      }
                      onChange={(e) =>
                        handleNoteChange(client.id + "_arrived", e)
                      }
                      variant="outlined"
                      size="small"
                      sx={{ maxWidth: 200, height: 48, overflow: "auto" }}
                      InputProps={{
                        sx: {
                          padding: "4px 8px",
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                        },
                      }}
                    />
                    <IconButton
                      onClick={() => handleToggleEdit(client.id, true)}
                      size="small"
                    >
                      <SaveIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TextField
                      value={getClientNoteArrived(client.id) || "No note"}
                      variant="outlined"
                      size="small"
                      disabled
                      multiline
                      sx={{ maxWidth: 200, height: 48, overflow: "auto" }}
                      InputProps={{
                        sx: {
                          padding: "4px 8px",
                          fontSize: "0.875rem",
                          lineHeight: 1.5,
                        },
                      }}
                    />
                    <IconButton
                      onClick={() => handleToggleEdit(client.id, true)}
                      size="small"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
      {/* Modal pour agrandir l'avatar */}
      <Dialog
        open={openImageDialog}
        onClose={handleCloseImageDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent sx={{ textAlign: "center" }}>
          {enlargedImage && (
            <>
              <img
                src={enlargedImage}
                alt="Enlarged Avatar"
                style={{ width: "100%", maxWidth: "300px" }}
              />
              {selectedClient && (
                <Typography variant="h6" sx={{ mt: 1 }}>
                  {selectedClient.firstName} {selectedClient.lastName}
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <IconButton onClick={handleCloseImageDialog}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
}

export default ExcursionDetailsModalMobile;
